import { render, staticRenderFns } from "./TheOrganizationLogo.vue?vue&type=template&id=50389826&"
import script from "./TheOrganizationLogo.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports